import React from 'react';

import { CashAccountSettings } from './components/CashAccountSettings';
import { DirectTradingAccountSettings } from './components/DirectTradingAccountSettings';
import { ManagedAccountSettings } from './components/ManagedAccountSettings';

import type { AccountSettingsUrlBuilders, RenderCloseAccountAction, RenderDeletePurposeAction } from './contentTypes';
import type { AccountSettingsAccount } from './data';

export type AccountSettingsModalContentProps = {
  account: AccountSettingsAccount | null | undefined;
  currentPath: string;
  urlBuilders: AccountSettingsUrlBuilders;
  renderDeletePurpose?: RenderDeletePurposeAction;
  renderCloseAccount?: RenderCloseAccountAction;
  clientName?: string;
  showInlineEditLinks?: boolean;
  purposelessCopy?: string;
};

export const AccountSettingsModalContent: React.FC<AccountSettingsModalContentProps> = ({
  account,
  currentPath,
  urlBuilders,
  renderDeletePurpose,
  renderCloseAccount,
  clientName,
  showInlineEditLinks,
  purposelessCopy,
}) => {
  if (!account) {
    return null;
  }

  switch (account.__typename) {
    case 'CashAccount':
      return (
        <CashAccountSettings
          account={account}
          currentPath={currentPath}
          urlBuilders={{
            accountDetails: urlBuilders.accountDetails,
            editPortfolio: urlBuilders.editPortfolio,
            editPurpose: urlBuilders.editPurpose,
            legalAccounts: urlBuilders.legalAccounts,
          }}
          renderCloseAccount={renderCloseAccount}
          purposelessCopy={purposelessCopy}
        />
      );
    case 'ManagedAccount':
      return (
        <ManagedAccountSettings
          account={account}
          currentPath={currentPath}
          urlBuilders={urlBuilders}
          renderDeletePurpose={renderDeletePurpose}
          renderCloseAccount={renderCloseAccount}
          clientName={clientName}
          showInlineEditLinks={showInlineEditLinks}
          purposelessCopy={purposelessCopy}
        />
      );
    case 'DirectTradingAccount':
      return (
        <DirectTradingAccountSettings
          account={account}
          urlBuilders={{
            accountDetails: urlBuilders.accountDetails,
            editPortfolio: urlBuilders.editPortfolio,
            legalAccounts: urlBuilders.legalAccounts,
          }}
          renderCloseAccount={renderCloseAccount}
        />
      );
    default:
      return null;
  }
};
